import React, {useEffect, useState} from 'react';
import Layout from "../components/Layout/Layout";
import Loading from "../components/UI/Loading";
import useAuthCalls from "../utilities/custom-hooks/auth-calls";
import {doGetPaymentIntent} from "../logic/payments";
import Row from "../components/UI/Row";
import PlayStoreLink from "../components/PurchaseSteps/PlayStoreLink";
import {useNavigate} from "react-router-dom";

const PaymentProcessed = () => {

    const {call} = useAuthCalls();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [message, setMessage] = useState("");
    const [intent, setIntent] = useState(null);
    const [loggedIn, setLoggedIn] = useState(false);

    const goToDashboard = () => {
        navigate('../dashboard', {replace: true});
    }

    useEffect(() => {
        const setup = async () => {
            setLoading(true);
            const urlParams = new URLSearchParams(window.location.search);
            let payment_intent = urlParams.get('payment_intent');
            let redirect_status = urlParams.get('redirect_status');

            if (payment_intent) {
                await call(
                    () => doGetPaymentIntent(payment_intent),
                    (res) => {
                        console.log(res);
                        if (res)
                            setIntent(res);
                    }
                );
            }

            setError("");
            setMessage("");

            switch (redirect_status) {
                case 'succeeded':
                    setMessage("Pagamento completato con successo!")
                    break;
                case 'processing':
                    setError("Il pagamento non è ancora stato completato. Attendi e ricarica");
                    break;
                case 'requires_payment_method':
                    break;
                default:
                    console.warn('Redirect status not received');
            }

            let user_token = sessionStorage.getItem('@user_token');
            if(user_token) {
                setLoggedIn(true);
            }

            setLoading(false);
        }

        setup();
    }, []);

    return (
        <Layout>
            <div className="h-screen mt-8 mx-4">
                <div className="text-gray-400 uppercase mb-4">Esito pagamento</div>
                {loading ?
                    <Loading label="Caricamento in corso" className=" font-bold text-md text-ea_green_to"/>
                    :
                    <div>
                        {error ?
                            <div>{error}</div>
                            :
                            <div>
                                {intent &&
                                <div>
                                    <Row
                                        className="w-full text-sm font-bold">{intent?.description ?? "Abbonamento"}</Row>
                                    <Row className="justify-between mb-4 border-b">
                                        <div>Importo</div>
                                        <div>{parseFloat(intent.amount / 100).toFixed(2)}€</div>
                                    </Row>
                                </div>
                                }

                                <div className="text-ea_green_to font-bold text-lg">{message}</div>

                                <div>Scarica l'APP per utilizzare il tuo abbonamento</div>

                                <div className="flex flex-row items-center justify-center mt-16">
                                    <PlayStoreLink/>
                                </div>

                                {loggedIn &&
                                <div className="mt-16">
                                    <div className="cursor-pointer inline-block hover:underline " onClick={goToDashboard}>Torna alla tua area riservata</div>
                                </div>
                                }

                            </div>
                        }

                    </div>
                }
            </div>

        </Layout>
    );
};

export default PaymentProcessed;
